// extracted by mini-css-extract-plugin
module.exports = {"listItem":"followListItem_listItem__2Ce86","item":"followListItem_item__IQcKt","more":"followListItem_more__2tN-c"};